import styled from 'styled-components';

import { MinBreakpoint } from '@xemplo/style-constants';

import {
  IconCommonStyles,
  IconContainerCommonStyles,
  IconSizeClassStyles,
  IconWrapperModeCommonStyles,
} from '../common';

export const StyledIconContainer = styled.div`
  display: none;

  @media ${MinBreakpoint.medium} {
    width: var(--header-icon-size, 56px);
    ${IconContainerCommonStyles};
    ${IconSizeClassStyles};
  }
`;

export const StyledHeaderIconWrapper = styled.span`
  display: none;
  flex-shrink: 0;

  ${IconWrapperModeCommonStyles};

  @media ${MinBreakpoint.medium} {
    width: var(--header-icon-size, 56px);
    height: var(--header-icon-size, 56px);
    border-radius: var(--header-icon-radius, 12px);
    transition: all 0.2s ease-out;
    ${IconCommonStyles};
    ${IconSizeClassStyles};
  }
`;
